<script setup lang="ts">
import LGHeader from '~/components/header/LGHeader.vue'
</script>

<template>
    <div>
        <LGHeader/>
        <div class="min-h-[100vh]" role="main">
            <NuxtPage />
        </div>
        <LazyFooterLGFooter/>
    </div>
</template>
